import { render, staticRenderFns } from "./GroupsTab.vue?vue&type=template&id=08a7b11a&scoped=true"
import script from "./GroupsTab.vue?vue&type=script&lang=js"
export * from "./GroupsTab.vue?vue&type=script&lang=js"
import style0 from "./GroupsTab.vue?vue&type=style&index=0&id=08a7b11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7b11a",
  null
  
)

export default component.exports